// noinspection JSAnnotator

export default {
    dev: {
        global: {
            API: '/shop-api/v2',
            home: 'https://test-www.nexon.com/main',
            account: 'https://test-www.nexon.com/account',
            wallet: 'https://test-www.nexon.com/wallet',
            checkout: 'https://test-www.nexon.com/checkout',
        },
        th: {
            API: '/shop-api/v2',
            home: 'https://test-th.nexon.com/main',
            account: 'https://test-th.nexon.com/account',
            wallet: 'https://test-th.nexon.com/wallet',
            checkout: 'https://test-th.nexon.com/checkout',
        },
        tw: {
            API: '/shop-api/v2',
            home: 'https://test-tw.nexon.com/main',
            account: 'https://test-tw.nexon.com/account',
            wallet: 'https://test-tw.nexon.com/wallet',
            checkout: 'https://test-tw.nexon.com/checkout',
        },
    },
    testPre: {
        global: {
            API: '/shop-api/v2',
            home: 'https://test-pre-www.nexon.com/main',
            account: 'https://test-pre-www.nexon.com/account',
            wallet: 'https://test-pre-www.nexon.com/wallet',
            checkout: 'https://test-pre-www.nexon.com/checkout',
        },
        th: {
            API: '/shop-api/v2',
            home: 'https://test-pre-thnexon.com/main',
            account: 'https://test-pre-th.nexon.com/account',
            checkout: 'https://test-pre-th.nexon.com/checkout',
        },
        tw: {
            API: '/shop-api/v2',
            home: 'https://test-pre-tw.nexon.com/main',
            account: 'https://test-pre-tw.nexon.com/account',
            wallet: 'https://test-pre-tw.nexon.com/wallet',
            checkout: 'https://test-pre-tw.nexon.com/checkout',
        },
    },
    test: {
        global: {
            API: '/shop-api/v2',
            home: 'https://test-www.nexon.com/main',
            account: 'https://test-www.nexon.com/account',
            wallet: 'https://test-www.nexon.com/wallet',
            checkout: 'https://test-www.nexon.com/checkout',
        },
        th: {
            API: '/shop-api/v2',
            home: 'https://test-th.nexon.com/main',
            account: 'https://test-th.nexon.com/account',
            wallet: 'https://test-th.nexon.com/wallet',
            checkout: 'https://test-th.nexon.com/checkout',
        },
        tw: {
            API: '/shop-api/v2',
            home: 'https://test-tw.nexon.com/main',
            account: 'https://test-tw.nexon.com/account',
            wallet: 'https://test-tw.nexon.com/wallet',
            checkout: 'https://test-tw.nexon.com/checkout',
        },
    },
    pre: {
        global: {
            API: '/shop-api/v2',
            home: 'https://pre-www.nexon.com/main',
            account: 'https://pre-www.nexon.com/account',
            wallet: 'https://pre-www.nexon.com/wallet',
            checkout: 'https://pre-www.nexon.com/checkout',
        },
        th: {
            API: '/shop-api/v2',
            home: 'https://pre-th.nexon.com/main',
            account: 'https://pre-th.nexon.com/account',
            wallet: 'https://pre-th.nexon.com/wallet',
            checkout: 'https://pre-th.nexon.com/checkout',
        },
        tw: {
            API: '/shop-api/v2',
            home: 'https://pre-tw.nexon.com/main',
            account: 'https://pre-tw.nexon.com/account',
            checkout: 'https://pre-tw.nexon.com/checkout',
        },
    },
    prod: {
        global: {
            API: '/shop-api/v2',
            home: 'https://www.nexon.com/main',
            account: 'https://www.nexon.com/account',
            wallet: 'https://www.nexon.com/wallet',
            checkout: 'https://www.nexon.com/checkout',
        },
        th: {
            API: '/shop-api/v2',
            home: 'https://th.nexon.com/main',
            account: 'https://th.nexon.com/account',
            wallet: 'https://th.nexon.com/wallet',
            checkout: 'https://th.nexon.com/checkout',
        },
        tw: {
            API: '/shop-api/v2',
            home: 'https://tw.nexon.com/main',
            account: 'https://tw.nexon.com/account',
            wallet: 'https://tw.nexon.com/wallet',
            checkout: 'https://tw.nexon.com/checkout',
        },
    },
};
